export default __webpack_public_path__ + "static/media/login-bg.f47df5a3.png";